function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// "command", "groupTitle", "divider" are not considered for this component
var parts = ["item", "list", "button", "selectedItem"];
var SHARED_OUTLINE = {
  outlineWidth: "0.12rem",
  outlineStyle: "solid",
  outlineColor: "text"
};
var baseStyleList = {
  bg: "#FFF",
  borderWidth: "1px",
  borderColor: "gray.100",
  borderStyle: "solid",
  borderRadius: "sm",
  "&:focus-within": _extends({}, SHARED_OUTLINE)
};
var baseStyleItem = {
  py: "0.4rem",
  px: "0.8rem",
  transitionProperty: "background",
  transitionDuration: "ultra-fast",
  transitionTimingFunction: "ease-in",
  _focus: {
    color: "green.500"
  },
  _active: {
    color: "green.500"
  },
  _expanded: {
    bg: "gray.100"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  }
};
var baseStyleButton = {
  transitionProperty: "common",
  transitionDuration: "normal",
  borderColor: ["transparent", "transparent", "gray.100"],
  borderStyle: "solid",
  borderRadius: "sm",
  textTransform: "none",
  fontWeight: "normal"
};
var baseStyle = {
  item: baseStyleItem,
  button: baseStyleButton,
  list: baseStyleList
};
export default {
  parts,
  baseStyle
};
//# sourceMappingURL=dropdown-menu.js.map